import { render, staticRenderFns } from "./WxInbound.vue?vue&type=template&id=dcb051a0&scoped=true&"
import script from "./WxInbound.vue?vue&type=script&lang=js&"
export * from "./WxInbound.vue?vue&type=script&lang=js&"
import style0 from "./WxInbound.vue?vue&type=style&index=0&id=dcb051a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb051a0",
  null
  
)

export default component.exports